import { LightRoutingLink, PrimaryButton } from "components/buttons/buttons";
import TextLiteralControl from "components/controls/text-literal-control/text-literal-control";
import WorkArea from "components/work-area/work-area";
import { currencyFormat } from "core/utils";
import head from "lodash/head";
import usePagos from "./use-pagos";

const PagosIndividualPage = () => {
	const {
		cargandoDatos,
		pagos,
		pagar
	} = usePagos();

	const pago = head(pagos);

	return (
		<WorkArea title="Pagar" path={["Pagar"]}>
			<div className="comprobante-banorte table-seleccion">
				<TextLiteralControl name="concepto" label="Concepto" defaultValue={pago?.concepto} />
				<TextLiteralControl name="importe" label="Importe total" defaultValue={currencyFormat(pago?.importe)} />
				<hr />
				<div className="c-footer">
					<div className="text-end">
						<LightRoutingLink disabled={cargandoDatos} className="me-3" to="/:segmento">Regresar</LightRoutingLink>
						<PrimaryButton disabled={cargandoDatos} onClick={pagar}>Pagar</PrimaryButton>
					</div>
				</div>
			</div>
		</WorkArea>
	);
};

export default PagosIndividualPage;